/* 
 * Export component file to be used on project
*/

import { SignInBar } from './SignInBar'
export default SignInBar
